import React from 'react';

const IngredientsManager = ({ingredients}) => {

    return (
        <section className="section">
            <h3>Ingredientes</h3>
            <div className="ingredients-list">
                {ingredients.map((ing, index) =>
                    <label className="ingredient-item" key={index}>
                        <input type="checkbox"/>
                        <span>{ing.item}</span>
                    </label>
                )}
            </div>
        </section>
    );
};

export default IngredientsManager;